import Module from './Module';
import StateModule from './StateModule';
import PageModule from './PageModule';
import * as log from 'loglevel';

class HistoryModule extends Module{
	constructor(bootstrap){
		super(bootstrap);

		this.historyChanged = this.historyChanged.bind(this);
		this.pageChanged 	= this.pageChanged.bind(this);

		this.dependencies.add(StateModule);
		this.dependencies.add(PageModule);

		this._first = true;

		if(!window.history.state){
			window.history.replaceState({url:window.location.href}, null);
		}
	}

	get priority(){
		return 5;
	}

	get enabled(){ return this._enabled; }
	set enabled(enabled){
		if(this._enabled != enabled){
			this._enabled = enabled;
			if(enabled){
				window.addEventListener('popstate', this.historyChanged);
				this.bootstrap.get(PageModule).on('page', this.pageChanged);
			}
			else{
				window.removeEventListener('popstate', this.historyChanged);
				this.bootstrap.get(PageModule).off('page', this.pageChanged);
			}
		}
	}

	historyChanged(e){
		log.debug('historyChanged', window.history.state);
		let stateModule = this.bootstrap.get(StateModule);
		this.bootstrap.get(StateModule).state = window.history.state;
	}

	pageChanged(page){
		const state = this.bootstrap.get(StateModule).state;
		window.history.pushState(state, state.title, state.url);
	}
}

export default HistoryModule;
export { HistoryModule };